import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ckeditor = _resolveComponent("ckeditor")!

  return (_openBlock(), _createElementBlock("article", null, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.esteRelatorio.titulo), 1),
    _createVNode(_component_ckeditor, {
      editor: _ctx.editor,
      modelValue: _ctx.esteRelatorio.texto,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.esteRelatorio.texto) = $event)),
      config: {}
    }, null, 8, ["editor", "modelValue"])
  ]))
}